import { useQuery } from '@tanstack/react-query';
import { getTimezoneValues } from '../utils/apis';
import { useEffect, useState } from 'react';

export const useTimeZones = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['timezones'],
    queryFn: getTimezoneValues,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 100,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const [timeZones, setTimeZones] = useState<string[]>([]);

  useEffect(() => {
    if (data?.data?.timeZones) {
      setTimeZones(data?.data?.timeZones);
    }
  }, [data?.data?.timeZones]);

  return {
    timeZones,
    isLoading,
    error,
  };
};
